
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class CTA extends Vue {
  isVisible: boolean = false

  get firstWidgetAgent (): string {
    return this.widgetAgents && this.widgetAgents[0]
  }

  get label (): string {
    return this.$store.getters.cta
  }

  get widgetAgents (): string {
    return this.$store.getters.widgetAgents
  }

  created (): void {
    const sessionStorageLabel = `chawgt-cta-shown-${this.$store.getters.account}`
    if (this.label !== '' &&
      this.$store.getters.needCta === true &&
      (
        !window.sessionStorage.getItem(sessionStorageLabel) ||
        this.$store.getters.forceCtaDisplay
      )) {
      window.setTimeout(() => {
        this.isVisible = true
        window.sessionStorage.setItem(
          sessionStorageLabel,
          'true'
        )
      }, this.$store.getters.showCtaDelay * 1000)
      window.setTimeout(() => {
        this.isVisible = false
      }, this.$store.getters.hideCtaDelay * 1000)
    }
  }
}
